import AuthorizedStep from './AuthorizedStep.vue';

export default AuthorizedStep;
